// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

const useTrackEventList = <T extends TrackEventParameters<any, any>>(
    parameters: T,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventListTrackerHook(ga.track.event, parameters, options);
};

export default useTrackEventList;
